import { atom, onConnect, onUpdate, reatomAsync, withDataAtom, withStatusesAtom } from '@reatom/framework';
import { chooseGameById, fetchGamesAction, GameMode } from '@whitesharx/starfall-frontend-core';
import { removeIrrelevantAnalyzes } from '~/src/screens/Analysis';

export const chosenGamesCountAtom = atom(0, 'chosenGamesCountAtom');

const GAMES_FILTER = { isFinished: true, contexts: Object.values(GameMode) };

export const getGamesAction = reatomAsync(async (ctx) => {
  const [chosenData, otherData] = await Promise.all([
    fetchGamesAction(ctx, { ...GAMES_FILTER, isChosen: true }),
    fetchGamesAction(ctx, { ...GAMES_FILTER, isChosen: false }),
  ]);

  chosenGamesCountAtom(ctx, chosenData.plays.length);

  return [...chosenData.plays, ...otherData.plays].filter((play) => play.winner?.reason !== 'ABORTED');
}, 'getGamesAction').pipe(withDataAtom([]), withStatusesAtom());

onConnect(getGamesAction.dataAtom, getGamesAction);
onUpdate(getGamesAction.dataAtom, (ctx, games) => {
  removeIrrelevantAnalyzes(games);
});

export const chooseGameAction = reatomAsync(
  (ctx, id: string, isChosen: boolean) => chooseGameById(id, isChosen),
  'chooseGameAction'
);

onUpdate(chooseGameAction.onFulfill, getGamesAction);
